import html2canvas from 'html2canvas';

/**
 * Export a DOM element as a PNG image.
 *
 * @param {HTMLElement|null} element - The DOM node to capture.
 * @param {Object} options - Optional configuration.
 * @param {string} [options.fileName='film-tile.png'] - Name of the downloaded file.
 * @param {Function} [options.onStart] - Callback invoked before the export begins.
 * @param {Function} [options.onComplete] - Callback invoked after the export completes (success or error).
 * @param {string} [options.backgroundColor='#ffffff'] - Background color used by html2canvas.
 * @returns {Promise<void>}
 */
export const exportElementAsImage = async (element, options = {}) => {
  const {
    fileName = 'film-tile.png',
    onStart,
    onComplete,
    backgroundColor = '#ffffff'
  } = options;

  if (!element) {
    console.warn('exportElementAsImage called without a valid element');
    return;
  }

  try {
    onStart?.();

    const canvas = await html2canvas(element, {
      backgroundColor,
      useCORS: true,
      scale: window.devicePixelRatio > 1 ? window.devicePixelRatio : 2,
      logging: false
    });

    const imageData = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = imageData;
    link.download = fileName;
    link.click();
  } catch (error) {
    console.error('Failed to export element as image:', error);
    throw error;
  } finally {
    onComplete?.();
  }
};

export default exportElementAsImage;

